// The globe's look (docs/ART-DIRECTION.md §1, docs/ROADMAP.md D34): its colours come from the palette, its brightness from
// the presentation tuning's globe knobs. globeLookOf() is to the globe what cityArtOf() is to the city art: the tuner
// retunes a running globe through the same path (GlobeRenderer.setLook).

import type { TuningValues } from '@taxwar/tuning'
import type { Palette } from '../palette'

/** Brightness multipliers of the globe's additive layers. */
export interface GlobeBrightness {
  readonly grid: number
  readonly landDots: number
  readonly coastline: number
  readonly borders: number
  readonly atmosphere: number
}

export interface GlobeLook {
  readonly palette: Palette
  readonly brightness: GlobeBrightness
}

export function globeLookOf(values: TuningValues, palette: Palette): GlobeLook {
  return {
    palette,
    brightness: {
      grid: values['globe.gridBrightness'],
      landDots: values['globe.landDotBrightness'],
      coastline: values['globe.coastlineBrightness'],
      borders: values['globe.borderBrightness'],
      atmosphere: values['globe.atmosphereBrightness'],
    },
  }
}
